var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { StyledText } from '../../../../../styles/text';
import { colors } from '../../../../../styles/theme';
export var Banner = styled(Inset)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  background: ", ";\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"])), colors.aliceBlue, colors.lightGrey, colors.lightGrey);
export var StyledDescription = styled(StyledText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-self: center;\n"], ["\n  align-self: center;\n"])));
var templateObject_1, templateObject_2;
